import {AxiosError} from 'axios';
import i18n from 'i18n';

export type BusinessError = {
    exceptionDescription: string;
    isBusinessException: boolean;
    message?: string;
};

export const getErrorText = (err: AxiosError): string | undefined => {
    const axiosError = err as AxiosError<Partial<BusinessError>>;

    const getDefaultError = () => {
        if (axiosError.response?.status === 403) {
            return i18n.t('networkErrors.noAccess', {ns: 'common'});
        }
        switch (err.config?.method) {
            case 'get':
                return i18n.t('networkErrors.get', {ns: 'common'});
            case 'delete':
                return i18n.t('networkErrors.delete', {ns: 'common'});
            case 'put':
                return i18n.t('networkErrors.put', {ns: 'common'});
            default:
                return i18n.t('networkErrors.fail', {ns: 'common'});
        }
    };

    const userText = axiosError?.config?.errorMessage;

    const errorMessage = userText || getDefaultError();

    if (axiosError?.response?.data?.isBusinessException) {
        const businessError = axiosError.response.data.exceptionDescription;

        return errorMessage ? `${errorMessage}. \n${businessError}` : businessError;
    }

    return errorMessage || axiosError?.response?.data?.message || axiosError.message;
};
